import React from 'react'
import {useIntl} from 'react-intl'
import {Text, Flex, Stack} from '@chakra-ui/react'
import {CONTINENT_MESSAGES} from '../../../constants'
import {IntlDisplayName} from './IntlDisplayName'
import PropTypes from 'prop-types'
import {BasketIcon} from '../../../components/icons'

const ContinentColumn = ({continent, currentLocation, ...props}) => {
    const {formatMessage} = useIntl()
    const {continentName, countries} = continent

    return (
        countries?.length > 0 && (
            // continent title and countries list
            <Stack spacing={4} {...props}>
                {continentName && (
                    <Text as="h2" textStyle="Regular 2XLarge">
                        {formatMessage(CONTINENT_MESSAGES[continentName])}
                    </Text>
                )}
                {/* list of countries */}
                <Stack spacing={6}>
                    {countries?.map((country) => (
                        // list of country names and languages
                        <Stack key={country.countryCode} spacing={2}>
                            {/* basket and list of country names */}
                            <Stack direction="row" spacing={2}>
                                {/* basket container - always take up the space to align country names list */}
                                <Flex width={4} height={5.5} align="center">
                                    {country.showBasketIcon && <BasketIcon width={4} height={4} />}
                                </Flex>

                                {/* list of country names and languages */}
                                <Stack spacing={2}>
                                    {/* country names list */}
                                    <Flex flexDir="row" flexWrap="wrap" gap={2} align="center">
                                        {/* english country name */}
                                        <IntlDisplayName
                                            flex="0 0 auto"
                                            languageCode={'en'}
                                            continentName={continentName}
                                            countryCode={country.countryCode}
                                            textStyle="Regular Medium"
                                            siteId={country.siteId}
                                            asLink={country.isLink}
                                            linkLocale={country.defaultLocale}
                                            currentLocation={currentLocation}
                                            englishCountryName={country.englishCountryName}
                                        />
                                        {/* country name in all available locales */}
                                        {country?.languageCodes
                                            ?.filter(Boolean)
                                            .map((languageCode, idx, list) => (
                                                <IntlDisplayName
                                                    key={languageCode}
                                                    flex="0 0 auto"
                                                    textStyle="Regular Medium"
                                                    continentName={continentName}
                                                    countryCode={country.countryCode}
                                                    languageCode={languageCode}
                                                    color="stokkeGray.dark"
                                                    suffix={idx < list.length - 1 ? ',' : ''}
                                                    currentLocation={currentLocation}
                                                />
                                            ))}
                                    </Flex>
                                    {!country?.isLink && country?.languageCodes?.length > 0 && (
                                        // languages list
                                        <Flex flexWrap="wrap" gap={2}>
                                            {country?.languageCodes?.map((languageCode) => (
                                                <IntlDisplayName
                                                    key={languageCode}
                                                    flex="0 0 auto"
                                                    type="language"
                                                    languageCode={languageCode}
                                                    continentName={continentName}
                                                    countryCode={country.countryCode}
                                                    siteId={country.siteId}
                                                    asLink={true}
                                                    textStyle="Regular Small"
                                                    currentLocation={currentLocation}
                                                />
                                            ))}
                                        </Flex>
                                    )}
                                </Stack>
                            </Stack>
                        </Stack>
                    ))}
                </Stack>
            </Stack>
        )
    )
}

ContinentColumn.propTypes = {
    continent: PropTypes.shape({
        continentName: PropTypes.string,
        countries: PropTypes.array
    }),
    currentLocation: PropTypes.object
}

export default ContinentColumn
